import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilderModule } from '../form-builder';
import { LoginFormComponent } from './login-form.component';

// const routes: Routes = [{ path: '', component: ImprintComponent }];

@NgModule({
    declarations: [LoginFormComponent],
    exports: [LoginFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        FormBuilderModule,
        //please do not change the order of the next 3 imports
        TranslateModule.forChild(),
        // RouterModule.forChild(routes),
        LocalizeRouterModule.forChild([])
    ],
    providers: []
})
export class LoginFormModule {}
